import React, { useState } from "react";
import { Layout, Menu, Button, Dropdown } from "antd";
import { HOME } from "../common/routes";
import {Route, Routes, useNavigate} from "react-router";
import { RosterUrl } from "../common/routes";
import { Roster } from "../common/pages/Roster";
import { G_DIVISIONS, G_AVAILABILITY, G_CONTACT, G_SCHEDULE, GoalieAssignUrl, GoalieAssignmentSeasonUrl, GoalieStatsUrl, GoalieGameHistoryUrl } from "./routes";
import { UserAuth } from "../common/interfaces";
import { useEnsuredUser, useUserContext } from "../common/contexts";
import { GoalieDashboard } from "./pages/GoalieDashboard";
import { GoaliePlacement } from "./pages/GoaliePlacement";
import { Availability } from "./pages/Availability";
import { Contact } from "./pages/Contact";
import { GoalieAssignmentSeason } from "./pages/GoalieAssignmentSeason";
import { GoalieSchedule } from "./pages/GoalieSchedule";
import { GoalieAssign } from "./pages/GoalieAssign";
import { GoalieStats } from "./pages/GoalieStats";
import { GoalieGameHistory } from "./pages/GoalieGameHistory";
import { IS_MOBILE } from "../common/utils";
import { useCookies } from "react-cookie";
import { Logo } from "../common/components/Logo";
import { LogoutOutlined, MenuOutlined } from "@ant-design/icons";

export function GoalieApp() {
  const user = useEnsuredUser();
  const isCoordinator = user.authTypes.includes(UserAuth.GOALIE_COORDINATOR);
  const [, , removeCookie] = useCookies(["username", "authToken"]);
  const { setUser } = useUserContext();
  const [menuVisible, setMenuVisible] = useState<boolean>(false);
  let navigate = useNavigate();

  const onLogout = () => {
    removeCookie("username", { path: "/" });
    removeCookie("authToken", { path: "/" });
    setUser(undefined);
  };

  const goToRoute = (route: string) => {
    navigate(route);
    setMenuVisible(false);
  };

  const mainMenu = (
    <Menu
      theme={IS_MOBILE ? "light" : "dark"}
      mode={IS_MOBILE ? "vertical" : "inline"}
    >
      <Menu.Item
        key={"home"}
        onClick={() => goToRoute(HOME)}
      >
        Home
      </Menu.Item>
      <Menu.Item
        key={"schedule"}
        onClick={() => goToRoute(G_SCHEDULE)}
      >
        Schedule
      </Menu.Item>
      <Menu.Item
        key={"availability"}
        onClick={() => goToRoute(G_AVAILABILITY)}
      >
        Availability
      </Menu.Item>
      <Menu.Item
        key={"contact"}
        onClick={() => goToRoute(G_CONTACT)}
      >
        Contact
      </Menu.Item>
      <Menu.Item
        key={"stats"}
        onClick={() => goToRoute(GoalieStatsUrl.createUrl())}
      >
        Stats
      </Menu.Item>
      {isCoordinator && (
        <Menu.ItemGroup title={<strong>Coordinator</strong>}>
          <Menu.Item
            key={"assignment"}
            onClick={() => goToRoute(GoalieAssignmentSeasonUrl.createUrl())}
          >
            Assign Goalies
          </Menu.Item>
          <Menu.Item
            key={"gamehistory"}
            onClick={() => goToRoute(GoalieGameHistoryUrl.createUrl())}
          >
            Game History
          </Menu.Item>
          <Menu.Item
            key={"divisions"}
            onClick={() => goToRoute(G_DIVISIONS)}
          >
            Set Divisions
          </Menu.Item>
        </Menu.ItemGroup>
      )}
      {IS_MOBILE && (
        <Menu.Item key={"logout"} onClick={onLogout}>
          <LogoutOutlined />
          <span>Logout</span>
        </Menu.Item>
      )}
    </Menu>
  );

  return (
    <Layout style={{ background: "white" }}>
      {IS_MOBILE ? (
        <Layout.Header style={{ background: "white", padding: 0 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}
          >
            <Logo />
            <Dropdown
              overlay={mainMenu}
              placement={"bottomRight"}
              visible={menuVisible}
              onVisibleChange={visible => {
                if (!visible) {
                  setMenuVisible(false);
                }
              }}
            >
              <Button
                icon={<MenuOutlined />}
                size={"large"}
                onClick={() => setMenuVisible(!menuVisible)}
              />
            </Dropdown>
          </div>
        </Layout.Header>
      ) : (
        <Layout.Sider width={150}>{mainMenu}</Layout.Sider>
      )}
      <Layout.Content style={{ paddingLeft: IS_MOBILE ? 0 : 10, paddingTop: IS_MOBILE ? 10 : 0 }}>
        <Routes>
          <Route path={HOME} element={<GoalieDashboard />} />
          <Route path={G_DIVISIONS} element={<GoaliePlacement />} />
          <Route path={G_SCHEDULE} element={<GoalieSchedule />} />
          <Route path={G_AVAILABILITY} element={<Availability />} />
          <Route path={G_CONTACT} element={<Contact />} />
          <Route path={GoalieStatsUrl.pattern} element={<GoalieStats />} />
          <Route path={GoalieGameHistoryUrl.pattern} element={<GoalieGameHistory />} />
          <Route path={GoalieAssignmentSeasonUrl.pattern} element={<GoalieAssignmentSeason />} />
          <Route path={GoalieAssignUrl.pattern} element={<GoalieAssign />} />
          <Route path={RosterUrl.pattern} element={<Roster />} />
        </Routes>
      </Layout.Content>
    </Layout>
  );
}
